import { CashOfficeUserActions } from 'src/common/enumerations/cash-office-user-actions';
import { popEmeraldModal } from '../../common/emerald-modal-manager/emerald-modal-manager';
import { CashOfficeMenuState } from '../../common/interfaces/states/CashOfficeMenuState';
import { closeDrawer } from '../components/cash-drawer-actions';
import { ShowTenderCount } from '../components/tender-count';
// TODO The Prettier version we are using does not like exporting types from another file.
// If/when Prettier is upgraded, we can export the types from the base index file.
import { TenderCountProps } from '../components/tender-count/tender-count';
import { processDeclaration } from './declaration';
import { HandleCashOfficeActions } from './handle-cash-office-actions';
import { processLoanAdd } from './loan-add';
import { processPaidIn } from './pay-in';
import { processPaidOut } from './pay-out';
import { processTenderPickup } from './tender-pickup';

export const ShowCashOfficeView = (
  action: CashOfficeUserActions,
  accountName?: string,
  accountId?: string,
  taxable?: boolean,
): void => {
  let props: Partial<TenderCountProps> = {};

  switch (action) {
    case CashOfficeUserActions.TillDeclaration:
      props = {
        onCancel: cancelFunction,
        submitTenderCount: declarationSubmit,
        title: 'DeclarationCommand',
        submitButtonText: 'DeclarationCommand',
        totalSubtitleText: 'Total_Declaration',
        testId: 'declaration-view',
      };
      break;
    case CashOfficeUserActions.LoanAdd:
      props = {
        onCancel: cancelFunction,
        submitTenderCount: loanSubmit,
        title: 'AddLoanCommand',
        submitButtonText: 'AddLoanCommand',
        totalSubtitleText: 'TotalLoan',
        testId: 'loanadd-view',
      };
      break;
    case CashOfficeUserActions.TenderPickup:
      props = {
        onCancel: cancelFunction,
        submitTenderCount: tenderPickupSubmit,
        title: 'TenderPickupCommand',
        submitButtonText: 'TenderPickupCommand',
        totalSubtitleText: 'TenderPickupAmount',
        testId: 'tender-pickup-view',
      };
      break;
    case CashOfficeUserActions.PaidOut:
      props = {
        onCancel: cancelPaidActivity,
        submitTenderCount: (tenderMenuGroups: CashOfficeMenuState): void => {
          popEmeraldModal();
          HandleCashOfficeActions.hidePaidAccountSelectionView();
          processPaidOut(tenderMenuGroups, accountId ?? '');
        },
        title: 'PaidOutCommand',
        submitButtonText: 'PaidOutCommand',
        totalSubtitleText: 'Paid_Out_Action_Subtitle',
        testId: 'paid-action-view',
        accountName: accountName,
      };
      break;
    case CashOfficeUserActions.PaidIn:
      props = {
        onCancel: cancelPaidActivity,
        submitTenderCount: (
          tenderMenuGroups: CashOfficeMenuState,
          taxAmount?: number,
          taxType?: string,
        ): void => {
          HandleCashOfficeActions.hidePaidAccountSelectionView();
          processPaidIn(tenderMenuGroups, accountId ?? '', taxable, taxAmount, taxType);
        },
        title: 'PaidInCommand',
        submitButtonText: 'PaidInCommand',
        totalSubtitleText: 'Paid_In_Action_Subtitle',
        testId: 'paid-action-view',
        isProfileTaxable: taxable,
        accountName: accountName,
      };
  }

  ShowTenderCount(props as TenderCountProps);
};

export function cancelFunction(): void {
  popEmeraldModal();
  closeDrawer();
}
export function cancelPaidActivity(): void {
  popEmeraldModal();
  HandleCashOfficeActions.hidePaidAccountSelectionView();
  closeDrawer();
}
export function declarationSubmit(tenderMenuGroups: CashOfficeMenuState): void {
  popEmeraldModal();
  processDeclaration(tenderMenuGroups);
}

export function loanSubmit(tenderMenuGroups: CashOfficeMenuState): void {
  popEmeraldModal();
  processLoanAdd(tenderMenuGroups);
}
export function tenderPickupSubmit(tenderMenuGroups: CashOfficeMenuState): void {
  popEmeraldModal();
  processTenderPickup(tenderMenuGroups);
}
